import Mock from 'mockjs';

const comments = [
  {
    评论时间: '2023-10-01 10:00:00',
    评论人头像: 'https://example.com/avatar1.jpg',
    评论人: '张三',
    评论人手机号: '12345678901',
    评论内容: '非常精彩的视频！',
    内容审核: '通过',
  },
  {
    评论时间: '2023-10-02 14:30:00',
    评论人头像: 'https://example.com/avatar2.jpg',
    评论人: '李四',
    评论人手机号: '10987654321',
    评论内容: '我非常喜欢这部作品。',
    内容审核: '审核中',
  },
  {
    评论时间: '2023-10-03 09:15:00',
    评论人头像: 'https://example.com/avatar3.jpg',
    评论人: '王五',
    评论人手机号: '10293847566',
    评论内容: '值得推荐！',
    内容审核: '拒绝',
  },
];
Mock.mock('http://localhost:5173/comment/list-all', 'GET', ({}) => {
  return {
    code: 0,
    message: 'success',
    data: comments,
    time: new Date().getTime(),
  };
});
